// ========================================
// Redefined U Store Australia - Main JavaScript
// ========================================

// Global state
let selectedFabricData = null;
let selectedColorOption = null;
let uploadedFile = null;

// Get fabric data from window object (populated by Liquid)
const fabricData = window.fabricsData || {};

// ========================================
// Smooth Scrolling
// ========================================
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});

// ========================================
// Fabric Modal Functions
// ========================================
function openFabricModal(fabricId) {
    const fabric = fabricData[fabricId];
    if (!fabric) return;

    selectedFabricData = { id: fabricId, ...fabric };
    selectedColorOption = null;

    document.getElementById('modalFabricImage').src = fabric.image || '';
    document.getElementById('modalFabricName').textContent = fabric.name || 'Fabric Name';
    document.getElementById('modalFabricRate').textContent = fabric.price || '';
    document.getElementById('modalFabricDescription').textContent = fabric.description || '';
    document.getElementById('modalMaterial').textContent = fabric.material || '';

    const modalSelectedColor = document.getElementById('modalSelectedColor');
    if (modalSelectedColor) modalSelectedColor.value = '';

    const colorPreview = document.getElementById('selectedColorPreview');
    if (colorPreview) colorPreview.innerHTML = '<span class="no-color-text">No color selected</span>';

    document.getElementById('modalSize').value = '';

    const modal = document.getElementById('fabricModal');
    modal.classList.add('active');
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
}

function closeFabricModal() {
    const modal = document.getElementById('fabricModal');
    modal.classList.remove('active');
    setTimeout(() => {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
    }, 300);
}

// ========================================
// Color Overlay Functions
// ========================================
function openColorOverlay() {
    if (!selectedFabricData) return;

    const colorImages = selectedFabricData.colorImages || [];
    const grid = document.getElementById('colorImagesGrid');
    grid.innerHTML = '';

    if (colorImages.length === 0) {
        grid.innerHTML = `
            <div class="no-colors-message">
                <i class="fas fa-info-circle"></i>
                <p>No color options available for this fabric.</p>
                <p>Please contact us for custom color requests.</p>
            </div>
        `;
    } else {
        colorImages.forEach(color => {
            const colorItem = document.createElement('div');
            colorItem.className = 'color-image-item222';
            if (selectedColorOption && selectedColorOption.name === color.name) {
                colorItem.classList.add('selected');
            }
            colorItem.innerHTML = `
                <div class="color-image-wrapper">
                    <img src="${color.image}" alt="${color.name}" loading="lazy">
                    <div class="color-check-icon">
                        <i class="fas fa-check-circle"></i>
                    </div>
                </div>
                <p class="color-name">${color.name}</p>
            `;
            colorItem.onclick = () => selectColorImage(colorItem, color);
            grid.appendChild(colorItem);
        });
    }

    const overlay = document.getElementById('colorOverlay');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
}

function closeColorOverlay() {
    const overlay = document.getElementById('colorOverlay');
    overlay.classList.remove('active');
}

function selectColorImage(element, colorData) {
    document.querySelectorAll('.color-image-item222').forEach(item => item.classList.remove('selected'));
    element.classList.add('selected');

    selectedColorOption = colorData;

    const modalSelectedColor = document.getElementById('modalSelectedColor');
    if (modalSelectedColor) modalSelectedColor.value = colorData.name;

    const colorPreview = document.getElementById('selectedColorPreview');
    if (colorPreview) {
        colorPreview.innerHTML = `
            <img src="${colorData.image}" alt="${colorData.name}" class="color-preview-img">
            <span class="color-preview-name">${colorData.name}</span>
        `;
    }

    setTimeout(() => closeColorOverlay(), 300);

    showNotification(`Color "${colorData.name}" selected!`, 'success');
}

// ========================================
// Add to Quote Form
// ========================================
function addToQuoteForm() {
    if (!selectedFabricData) {
        showNotification('No fabric selected!', 'error');
        return;
    }

    const modalSelectedColor = document.getElementById('modalSelectedColor');
    const chosenColorName = modalSelectedColor ? modalSelectedColor.value : (selectedColorOption ? selectedColorOption.name : '');

    if (!chosenColorName) {
        showNotification('Please select a color option!', 'error');
        return;
    }

    const sizeInput = document.getElementById('modalSize');
    if (!sizeInput.value) {
        showNotification('Please select a size!', 'error');
        sizeInput.focus();
        return;
    }

    const fabricInput = document.getElementById('selectedFabric');
    const colourInput = document.getElementById('colourOption');
    const sizeField = document.getElementById('sizeOption');

    if (fabricInput) fabricInput.value = `${selectedFabricData.name} - ${selectedFabricData.price}`;
    if (colourInput) colourInput.value = chosenColorName;
    if (sizeField) sizeField.value = sizeInput.value;

    closeFabricModal();
    setTimeout(() => {
        const targetSection = document.getElementById('design-selection');
        if (targetSection) targetSection.scrollIntoView({behavior: 'smooth', block: 'start'});
    }, 400);

    showNotification('Fabric added to quote form!', 'success');
}

// ========================================
// Modal Close on Outside Click
// ========================================
const fabricModal = document.getElementById('fabricModal');
if (fabricModal) fabricModal.addEventListener('click', e => { if (e.target === fabricModal) closeFabricModal(); });

const colorOverlay = document.getElementById('colorOverlay');
if (colorOverlay) colorOverlay.addEventListener('click', e => { if (e.target === colorOverlay) closeColorOverlay(); });

// ========================================
// Design Gallery Functions
// ========================================
function openDesignGallery() {
    const galleryModal = document.getElementById("galleryModal");
    if (!galleryModal) return;
    galleryModal.style.display = "flex";
    document.body.style.overflow = "hidden";
}

function closeDesignGallery() {
    const galleryModal = document.getElementById("galleryModal");
    if (galleryModal) {
        galleryModal.style.display = "none";
        document.body.style.overflow = "auto";
    }
}

function openDesignDetail(designId) {
    const design = window.designsData[designId];
    if (!design) return;

    document.getElementById("detailDesignName").textContent = design.name;
    const imagesContainer = document.getElementById("detailImages");
    imagesContainer.innerHTML = "";

    if (design.gallery_images && design.gallery_images.length > 0) {
        design.gallery_images.forEach(img => {
            const imgEl = document.createElement("img");
            imgEl.src = img;
            imgEl.alt = design.name;
            imagesContainer.appendChild(imgEl);
        });
    } else {
        const imgEl = document.createElement("img");
        imgEl.src = design.main_image;
        imgEl.alt = design.name;
        imagesContainer.appendChild(imgEl);
    }

    const modal = document.getElementById("designDetailModal");
    modal.style.display = "flex";
    document.body.style.overflow = "hidden";

    const addBtn = document.getElementById("addDesignButton");
    addBtn.onclick = function () {
        document.getElementById("designChoice").value = design.name;
        closeDesignDetail();
        closeDesignGallery();
        setTimeout(() => {
            const quoteSection = document.getElementById("quote-request");
            if (quoteSection) quoteSection.scrollIntoView({behavior: "smooth", block: "start"});
        }, 300);
        showNotification('Design added to quote form!', 'success');
    };
}

function closeDesignDetail() {
    const modal = document.getElementById("designDetailModal");
    modal.style.display = "none";
    document.body.style.overflow = "auto";
}

// ========================================
// Simple Thank You Button Message
// ========================================


// ========================================
// File Upload Handling
// ========================================
const designUpload = document.getElementById('designUpload');
if (designUpload) {
    designUpload.addEventListener('change', function(e) {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                showNotification('File size must be less than 5MB', 'error');
                return;
            }

            uploadedFile = file;
            const reader = new FileReader();
            reader.onload = function(event) {
                const preview = document.getElementById('uploadPreview');
                const previewImage = document.getElementById('previewImage');
                const uploadLabel = document.querySelector('.upload-label');

                previewImage.src = event.target.result;
                preview.classList.remove('hidden');
                uploadLabel.style.display = 'none';
            };
            reader.readAsDataURL(file);
        }
    });
}

function removeUpload() {
    uploadedFile = null;
    const preview = document.getElementById('uploadPreview');
    const uploadLabel = document.querySelector('.upload-label');
    const designUploadInput = document.getElementById('designUpload');

    if (preview) preview.classList.add('hidden');
    if (uploadLabel) uploadLabel.style.display = 'flex';
    if (designUploadInput) designUploadInput.value = '';
}

// ========================================
// Notification System
// ========================================
function showNotification(message, type = 'success') {
    const existingNotification = document.querySelector('.notification');
    if (existingNotification) existingNotification.remove();

    const notification = document.createElement('div');
    notification.className = 'notification';
    notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: ${type === 'success' ? '#4caf50' : '#f44336'};
        color: white;
        padding: 15px 25px;
        border-radius: 10px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
        z-index: 10000;
        animation: slideInRight 0.3s ease;
        max-width: 300px;
    `;
    notification.innerHTML = `
        <i class="fas fa-${type === 'success' ? 'check-circle' : 'exclamation-circle'}" 
           style="margin-right: 10px;"></i>
        ${message}
    `;

    document.body.appendChild(notification);

    setTimeout(() => {
        notification.style.animation = 'slideOutRight 0.3s ease';
        setTimeout(() => notification.remove(), 300);
    }, 3000);
}

// Add notification animations
const style = document.createElement('style');
style.textContent = `
    @keyframes slideInRight {
        from {transform: translateX(400px); opacity: 0;}
        to {transform: translateX(0); opacity: 1;}
    }
    
    @keyframes slideOutRight {
        from {transform: translateX(0); opacity: 1;}
        to {transform: translateX(400px); opacity: 0;}
    }
`;
document.head.appendChild(style);
